<mat-form-field>
    <mat-label>{{ props.label || 'User' }}</mat-label>
    <mat-autocomplete #userAutocomplete="matAutocomplete" [displayWith]="displayFn">
        <mat-option [value]="null"><strong>Myself</strong></mat-option>
        @for (user of filteredUsers(); track $index) {
            <mat-option [value]="user.username">{{ user.username }}</mat-option>
        }
        @if (users.isLoading()) {
            <mat-option>Loading...</mat-option>
        }
    </mat-autocomplete>
    <input
        type="text"
        matInput
        autocompleteEnforceSelection
        [matAutocomplete]="userAutocomplete"
        [placeholder]="users.isLoading() ? 'Loading...' : 'Pick a user'"
        [formControl]="selectedUserControl"
    />
    @if (!!props.description) {
        <mat-hint>{{ props.description }}</mat-hint>
    }
</mat-form-field>
